import { FC, lazy, useState } from "react"
import { useNavigate } from "react-router-dom"
import { IStudent } from "types"
import { t } from "i18next"

import { Box, Grid } from "@mui/material"
import { Check, RadioButtonUnchecked } from "@mui/icons-material"

import MeetingForm from 'components/organisms/forms/MeetingForm'
import ConsentEvaluationForm from 'components/organisms/forms/special/ConsentEvaluationForm'
import ConsentPlacementForm from 'components/organisms/forms/special/ConsentPlacementForm'
import EligibilityForm from 'components/organisms/forms/special/EligibilityForm'
import TeamRecommendationForm from 'components/organisms/forms/special/TeamRecommendationForm'
import PriorNoticeForm from 'components/organisms/forms/special/PriorNoticeForm'


interface IProps {
    student: IStudent
    tabText?: string
    tabKey?: string
}

const Referral: FC<IProps> = ({ student }) => {

    const navigate  =  useNavigate()

    const [step, setStep] = useState(0)

    const steps = [
        {title: t('special.student-interview'), checked: true, component: <MeetingForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.parent-interview'), checked: true, component: <MeetingForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.consent-for-evaluation'), checked: true, component: <ConsentEvaluationForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.consent-for-placement'), checked: true, component: <ConsentPlacementForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.eligibility'), checked: false, component: <EligibilityForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.team-recommendation'), checked: false, component: <TeamRecommendationForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.prior-written-notice'), checked: false, component: <PriorNoticeForm action={'add'} id={''} viewOnly={false} /> },
    ]


    return <div style={{ padding: '0px' }}>    
        <Grid container>
            <Grid item xs={12} lg={3}>
                <div style={{ padding: '20px' }}>
                    <div style={{ padding: '20px', backgroundColor: '#f4f4f4', borderRadius: '5px' }}>
                        {steps.map((s, index) => <Box 
                            className='transparent-background' 
                            onClick={() => setStep(index)}
                            sx={{ 
                                display: 'flex', 
                                cursor: 'pointer', 
                                marginBottom: '20px',
                                fontWeight: step === index ? 'bold' : 'normal',
                                '&:hover': {
                                    fontWeight: 'bold'
                                }
                            }}>
                                {s.checked && <Check sx={{ color: '#7ED321', fontSize: '20px', marginRight: '10px' }} />}
                                {!s.checked && <RadioButtonUnchecked sx={{ fontSize: '20px', marginRight: '10px'  }} />}
                                {index+1}. {s.title}
                        </Box>)}
                    </div>
                </div>
            </Grid>
            <Grid item xs={12} lg={9}>
                <div style={{ padding: '20px' }}>
                    <div style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '20px'}}>{step+1}. {steps[step].title}</div>
                    {steps[step].component}    
                </div>
            </Grid>
        </Grid>
    </div>
}
export default Referral